import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Group } from '@mantine/core';
import axios from 'axios';
import ApiLinks from '../../Navlinks/ApiLinks';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CustomMantineTable from '../../Utilities/CustomMantineTable';
import { DeleteRecords, EditRecord } from '../../Utilities/EditorDeleteRecords';
import { formatDate } from '../../Utilities/OtherBasicFunction';


function Enquiry() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);


  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/${ApiLinks.Enquiry_list}/${user.compcode}`)
      .then((response) => {
        if (response.data.status) {
          setData(response.data.data);
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        setLoading(false);
      });

  }, [user.compcode]);



  const columns = [
    {
      id: 'actions',
      header: 'Actions',
      size: '100',
      Cell: ({ row }) => (
        <Group spacing="xs">

          <DeleteRecords
            id={row.original.id}
            endpoint={`${ApiLinks.Enquiry_Delete}`}
            compcode={user.compcode}
            onDeleteSuccess={(deletedId) =>
              setData((prev) => prev.filter((item) => item.id !== deletedId))
            }
          />
        </Group>
      ),
    },
    {
      accessorKey: 'date',
      header: 'Date',
      Cell: ({ cell }) => formatDate(cell.getValue()),
    },
    {
      accessorKey: 'propertyname',
      header: 'propertyname',
    },
    {
      accessorKey: 'enquirytype',
      header: 'enquirytype',
    },

    {
      accessorKey: 'name',
      header: 'name',
    },
    {
      accessorKey: 'email',
      header: 'email',
    },
    {
      accessorKey: 'mobileno',
      header: 'mobileno',
    },
    {
      accessorKey: 'message',
      header: 'message',
    }

  ];

  return (
    <Box>


      <Group position="apart" mb="md">
        <h2>Enquiry List</h2>

      </Group>
      <Grid justify="center">
        <Grid.Col span={12}>
          <CustomMantineTable columns={columns} data={data} loading={loading} />
        </Grid.Col>
      </Grid>
    </Box>

  );
}

export default Enquiry;
